import { createRouter } from '@tanstack/react-router';
import { Route as rootRoute } from './routes/__root';
import { Route as indexRoute } from './routes/index';
import { Route as newCustomerRoute } from './routes/customers/new';
import { Route as customerDetailRoute } from './routes/customers/$id';
import { Route as plansRoute } from './routes/plans';
import { Route as teamRoute } from './routes/team';

import { Route as impersonateRoute } from './routes/impersonate';
import { Route as acceptInviteRoute } from './routes/accept-invite';

import { Route as loginRoute } from './routes/login';
import { Route as verifyRoute } from './routes/verify';
import { Route as checkEmailRoute } from './routes/check-email';

import { Route as s3EndpintsRoute } from './routes/s3-endpoints';

const routeTree = rootRoute.addChildren([
  indexRoute,
  newCustomerRoute,
  customerDetailRoute,
  plansRoute,
  teamRoute,
  impersonateRoute,
  acceptInviteRoute,
  loginRoute,
  verifyRoute,
  checkEmailRoute,
  s3EndpintsRoute,
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
